import Entity from 'utilities/entity';

class Phase extends Entity {
    
}

export default new Phase();
